import React from 'react'
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { RolesResponseType, RoleType } from '../response/RolesResponse';
import RequireAuth from '../../../auth/middleware/RequireAuth';

interface RolesTableProps {
    roles: RolesResponseType;
    onUpdate: (id: number) => void;
    onDelete: (id: number) => void;
    onAssignUser: (id: number) => void;
    onAssignPermission: (id: number) => void;
}

const RolesTable: React.FC<RolesTableProps> = ({ roles, onUpdate, onDelete, onAssignUser, onAssignPermission }) => {
    return (
        <div className="table">
            <table className="table table-hover table-vcenter">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Display Name</th>
                        <th>Permissions</th>
                        <th>Users</th>
                        <th>Create At</th>
                        <th className="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {roles.data.length === 0 && (
                        <tr>
                            <td colSpan={5} className="text-center">No data available</td>
                        </tr>
                    )}
                    {roles.data.length > 0 && roles.data.map((role: RoleType, index: number) => (
                        <React.Fragment key={index}>
                            <tr>
                                <td>{role.name}</td>
                                <td>{role.display_name}</td>
                                <td>{role.permissions.map((permission) => permission.name).join(', ').substring(0, 70)}{role.permissions.length > 0 ? '...' : (
                                    <span className="text-danger">no permissions</span>
                                )}</td>
                                <td>{role.users.map((user) => (
                                    <OverlayTrigger
                                        key={user.id}
                                        placement='top'
                                        overlay={
                                            <Tooltip id={`tooltip-${user.id}`}>
                                                {user.name}
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            key={user.id}
                                            className="avatar-list avatar-list-stacked d-inline cursor-pointer"
                                        >
                                            <span
                                                className="avatar avatar-sm rounded-circle"
                                                title={user.name}
                                            >
                                                {user.name
                                                    .split(" ")
                                                    .map((word) => word[0])
                                                    .join("")}
                                            </span>
                                        </div>
                                    </OverlayTrigger>
                                ))}
                                    {role.name !== 'dev' && (
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['role_assign_user']} asComponent>
                                            <button
                                                onClick={() => onAssignUser(role.id)}
                                                className="btn btn-sm btn-outline-primary avatar-list avatar-list-stacked d-inline cursor-pointer avatar avatar-sm rounded-circle">
                                                +
                                            </button>
                                        </RequireAuth>
                                    )}
                                </td>
                                <td>{role.created_at}</td>
                                <td className="text-end">
                                    {role.name !== 'dev' && (
                                        <Dropdown>
                                            <Dropdown.Toggle variant="default" id="dropdownMenuButton1">
                                                Actions
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }}>
                                                {/* <Dropdown.Item href="#">View</Dropdown.Item> */}
                                                <RequireAuth requiredRoles={['dev']} requiredPermissions={['role-update']} asComponent>
                                                    <Dropdown.Item href="#" onClick={() => {
                                                        onUpdate(role.id);
                                                    }}>Edit</Dropdown.Item>
                                                </RequireAuth>
                                                <RequireAuth requiredRoles={['dev']} requiredPermissions={['role_assign_permission']} asComponent>
                                                    <Dropdown.Item href="#" onClick={() => {
                                                        onAssignPermission(role.id);
                                                    }}>Assign Permission</Dropdown.Item>
                                                </RequireAuth>
                                                <RequireAuth requiredRoles={['dev']} requiredPermissions={['role-delete']} asComponent>
                                                    <Dropdown.Item href="#" onClick={() => {
                                                        onDelete(role.id);
                                                    }}>
                                                        Remove
                                                    </Dropdown.Item>
                                                </RequireAuth>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default RolesTable